import { DialogTitle, Stack, Typography } from "@mui/material";
import { CommonDialog } from "@/components/common/CommonDialog";
import { FormButtonGroup } from "@/components/form";
import { CancelExtensionModal } from "./CancelExtensionModal";

interface QuestionnairesModalsProps {
    isActivateModalOpen: boolean;
    isCancelModalOpen: boolean;
    isLoading: boolean;
    onCloseActivateModal: () => void;
    onCloseCancelModal: () => void;
    onConfirmActivate: () => void;
    onConfirmCancel: () => void;
    agentName: string;
}

export function QuestionnairesModals({
    isActivateModalOpen,
    isCancelModalOpen,
    isLoading,
    onCloseActivateModal,
    onCloseCancelModal,
    onConfirmActivate,
    onConfirmCancel,
    agentName,
}: QuestionnairesModalsProps) {
    return (
        <>
            <CommonDialog
                isOpen={isActivateModalOpen}
                handleClose={onCloseActivateModal}
                maxWidth="sm"
            >
                <DialogTitle align="center">
                    Confirmar Ativação da extensão {agentName}
                </DialogTitle>

                <Stack spacing={3}>
                    <Typography
                        variant="subtitle2"
                        fontWeight="500"
                        align="center"
                        mb={2}
                    >
                        Ao confirmar, você ativará a extensão {agentName} e terá acesso
                        imediato aos benefícios exclusivos. Aproveite essa nova experiência!
                    </Typography>

                    <FormButtonGroup
                        onGoBackButtonClick={onCloseActivateModal}
                        onNextButtonClick={onConfirmActivate}
                        loading={isLoading}
                        goBackButtonText="Fechar"
                        nextButtonText={isLoading ? "Ativando..." : "Confirmar"}
                        disabled={isLoading}
                        maxWidth
                    />
                </Stack>
            </CommonDialog>

            <CancelExtensionModal
                isOpen={isCancelModalOpen}
                isLoading={isLoading}
                onClose={onCloseCancelModal}
                onConfirm={onConfirmCancel}
                extensionName={agentName}
            />
        </>
    );
}

